import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4807ad4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-padding-top ion-text-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  src: "https://www.gravatar.com/avatar?d=mm&s=140",
  alt: "profileImage"
}
const _hoisted_4 = { style: {"font-weight":"bold"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Message", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Timestamp: ", -1))
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Trace: ", -1))
const _hoisted_16 = { class: "about-info" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "ion-padding-top ion-padding-start" }, "über MobiPoints", -1))
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_avatar, { class: "center-profile-image" }, {
      default: _withCtx(() => [
        ($setup.getUserImage)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: $setup.getUserImage,
              alt: "profileImage",
              class: "profile-image-size"
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("img", _hoisted_3))
      ]),
      _: 1
    }),
    _createElementVNode("h2", null, _toDisplayString($setup.getFullName), 1),
    _createVNode(_component_ion_badge, { color: "success" }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, _toDisplayString($setup.currentPoints), 1),
        _createTextVNode(" Mobi Points")
      ]),
      _: 1
    }),
    ($setup.currentPoints === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
          _createTextVNode("Du hast noch keine Punkte gesammelt!"),
          _hoisted_6,
          _createTextVNode("Starte gleich mit deinem ersten Tracking! ")
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_7, "Mach weiter so! Du bist auf einen guten Weg!")),
    _createVNode(_component_ion_list, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_item, {
          "router-link": "/mobipoints/transactions",
          "router-direction": "back"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Mein Wallet")
          ]),
          _: 1
        }),
        _createVNode(_component_ion_item, {
          "router-link": "/profile/userLocation",
          "router-direction": "back"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Standorte verwalten")
          ]),
          _: 1
        }),
        _createVNode(_component_ion_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_label, null, {
              default: _withCtx(() => [
                _createTextVNode("Dark Mode")
              ]),
              _: 1
            }),
            _createVNode(_component_ion_toggle, {
              color: "dark",
              onIonChange: $setup.toggleDarkMode,
              checked: $setup.darkMode,
              value: $setup.darkMode
            }, null, 8, ["onIonChange", "checked", "value"])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_label, null, {
              default: _withCtx(() => [
                _createTextVNode("Tracking Auto Stop")
              ]),
              _: 1
            }),
            _createVNode(_component_ion_toggle, {
              color: "dark",
              onIonChange: $setup.toggleTrackingAutoStop,
              checked: $setup.trackingAutoStop,
              value: $setup.trackingAutoStop
            }, null, 8, ["onIonChange", "checked", "value"])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_label, null, {
              default: _withCtx(() => [
                _createElementVNode("span", { innerHTML: $setup.trackingStopConfirmItemTitle }, null, 8, _hoisted_8)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_toggle, {
              color: "dark",
              onIonChange: $setup.toggleTrackingStopConfirm,
              checked: $setup.trackingStopConfirm,
              value: $setup.trackingStopConfirm
            }, null, 8, ["onIonChange", "checked", "value"])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_item, {
          "router-link": "/redeem/voucher",
          "router-direction": "back"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Gutschein einlösen")
          ]),
          _: 1
        }),
        _createVNode(_component_ion_item, {
          button: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openTutorial()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Tutorial ansehen")
          ]),
          _: 1
        }),
        _createVNode(_component_ion_item, {
          "router-link": "/privacy-crudafoch",
          "router-direction": "back"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Datenschutz")
          ]),
          _: 1
        }),
        _createVNode(_component_ion_item, {
          "router-link": "/impress",
          "router-direction": "back"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Impressum")
          ]),
          _: 1
        }),
        _createVNode(_component_ion_item, {
          "router-link": "/terms",
          "router-direction": "back"
        }, {
          default: _withCtx(() => [
            _createTextVNode("AGB")
          ]),
          _: 1
        }),
        _createVNode(_component_ion_item, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.logout()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Logout")
          ]),
          _: 1
        }),
        ($setup.isDevelopmentEnv() || $setup.isDeveloper())
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_ion_item, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openLogs(true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("DEVELOPMENT MODE - LOGS")
                ]),
                _: 1
              }),
              _createVNode(_component_ion_modal, {
                "is-open": $setup.isLogsOpen,
                "css-class": "my-custom-class",
                "swipe-to-close": true,
                keyboardClose: true,
                onDidDismiss: _cache[5] || (_cache[5] = ($event: any) => ($setup.openLogs(false)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_content, { class: "ion-padding-top" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_buttons, {
                        class: "ion-padding-horizontal ion-padding-top ion-justify-content-between",
                        style: {"display":"flex"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            color: "warning",
                            class: "ion-margin-start",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.resetLog()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: $setup.icons.trashOutline
                              }, null, 8, ["icon"]),
                              _createVNode(_component_ion_label, { style: {"margin-left":".25rem"} }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Logs leeren")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_ripple_effect)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_button, {
                            color: "medium",
                            class: "ion-margin-start",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openLogs(false)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: $setup.icons.close
                              }, null, 8, ["icon"]),
                              _createVNode(_component_ion_label, { style: {"margin-left":".25rem"} }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Close")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_ripple_effect)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.logsSortedDesc, (log, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          class: "ion-padding"
                        }, [
                          (log.message)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _hoisted_11,
                                _createElementVNode("span", null, _toDisplayString(log.message), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (log.timestamp)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _hoisted_13,
                                _createElementVNode("span", null, _toDisplayString($setup.dateHelper.formatTimestamp(log.timestamp)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (log.trace)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _hoisted_15,
                                _createElementVNode("span", null, _toDisplayString(log.trace), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["is-open"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("p", {
        class: "ion-padding-start ion-padding-end",
        innerHTML: $setup.aboutMobiPoints
      }, null, 8, _hoisted_18),
      _createElementVNode("p", {
        style: {"margin":"auto","text-align":"center","padding-bottom":"15px","font-size":"9px"},
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.enableDeveloperMode && $setup.enableDeveloperMode(...args)))
      }, [
        _createTextVNode(" Version: " + _toDisplayString($setup.appVersion) + " - ", 1),
        ($setup.isNativePlatform())
          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Native"))
          : (_openBlock(), _createElementBlock("span", _hoisted_20, "Web"))
      ])
    ])
  ]))
}